import React, { useEffect, useRef, useState } from 'react';
import { getMediaPath } from 'app/functions';
import './index.scss';

const StripNavItem = ({ uniqueId, title, icon, index, isSelected, indicatorStateMethod, setSelectedIndex }) => {
    const observer = useRef(null);
    const [targetElement, setTargetElement] = useState(null);

    useEffect(() => {
        if (targetElement) {
            const configurations = {
                root: null,
                rootMargin: '-45% 0px -45% 0px',
                threshold: 0,
            };

            observer.current = new IntersectionObserver(observerHandler, configurations);
            observer.current.observe(targetElement);
        }

        return () => {
            if (targetElement) {
                observer.current.unobserve(targetElement);
            }
        }
    }, [targetElement]);

    useEffect(() => {
        const element = document.querySelector('#' + uniqueId);
        setTargetElement(element);
    }, []);

    const observerHandler = (e) => {
        if (e[0].isIntersecting) {
            indicatorStateMethod((10 + (10 * index)) + (index * 45));
            setSelectedIndex(index)
        }
    };

    const scrollToElement = (id) => {
        const parentElement = document.querySelector(`#${id}`);
        const scrollElement = parentElement.querySelector('.scroll-to-here');

        const elementToScrollTo = scrollElement ?? parentElement;

        if (elementToScrollTo) {
            elementToScrollTo.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            });
        }
    };

    let itemImage = getMediaPath(icon)

    return (
        <div
            className='strip-nav-item-wrapper'
            onClick={() => scrollToElement(uniqueId, index)}
        >
            <div className="icon-wrapper">
                <img src={itemImage} alt="/" className={isSelected ? "icon selectedIcon" : "icon"} />
            </div>

            <div className="label">
                {title}
            </div>
        </div>
    );
}

export default StripNavItem;
